<template>
  <div class="models-view">
    <template v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C" />
    </template>
    <template v-else>
      <inner-navigation>
        <router-link to="/models/all">Руководства по эксплуатации</router-link>
      </inner-navigation>

      <component :is="tableType" />

      <!-- <paginator :model="meta.list_data"/> -->
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableElement from '@/components/common/TableElement';

import * as tables from './tables';

export default {
  name: 'models-view',

  components: {
    TableElement,
    ...tables,
  },

  computed: {
    ...mapGetters({
      loading: 'config/loading',
      error: 'config/error',
      meta: 'config/meta',
    }),

    tableType() {
      return this.$route.meta.tableType;
    },
  },
};
</script>

<style lang="scss" scoped>
.models-view {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100%;
}
</style>
